import { useMemo } from "react";


const MAX_LOGS = 200;

const groupLogs = (logs) => {
  const map = new Map();
  const ordered = [];

  logs.forEach((log) => {
    const count = typeof log.count === "number" ? log.count : 1;
    const key = `${log.type || "info"}::${log.message}`;
    if (map.has(key)) {
      const existing = map.get(key);
      existing.count += count;
      if (log.meta) existing.meta = log.meta;
      existing.id = log.id;
      return;
    }
    const entry = {
      ...log,
      count,
    };
    map.set(key, entry);
    ordered.push(entry);
  });

  return ordered;
};

const splitMessage = (message) => {
  if (!message) return { main: "", stack: null };
  const idx = message.indexOf("\nStack:");
  if (idx === -1) return { main: message, stack: null };
  return { main: message.slice(0, idx), stack: message.slice(idx + 1) };
};

const Console = ({ logs, onClear }) => {
  const displayLogs = useMemo(() => {
    const sliced = logs.length > MAX_LOGS ? logs.slice(-MAX_LOGS) : logs;
    return groupLogs(sliced);
  }, [logs]);

  const hiddenCount = Math.max(0, logs.length - MAX_LOGS);

  return (
    <section className="animation-workbench-console">
      <div className="animation-workbench-panel-head">
        <h3>Console</h3>
        <button
          type="button"
          className="animation-workbench-btn animation-workbench-clear-btn"
          onClick={onClear}
        >
          Clear
        </button>
      </div>

      <div className="animation-workbench-console-list">
        {logs.length === 0 && (
          <p className="animation-workbench-empty">No logs yet</p>
        )}
        {hiddenCount > 0 && (
          <p className="animation-workbench-log-meta">
            Showing last {MAX_LOGS} of {logs.length} logs
          </p>
        )}
        {displayLogs.map((log) => (
          <article
            key={log.id}
            className={`animation-workbench-log ${log.type || "info"}`}
          >
            {(() => {
              const { main, stack } = splitMessage(log.message || "");
              return (
                <>
                  <p className="animation-workbench-log-message">{main}</p>
                  {stack && (
                    <pre className="animation-workbench-log-stack">{stack.trim()}</pre>
                  )}
                </>
              );
            })()}
            {log.count > 1 && (
              <p className="animation-workbench-log-meta">x{log.count}</p>
            )}
            {((log.meta?.line && log.meta?.char) ||
              typeof log.meta?.time === "number") && (
              <p className="animation-workbench-log-meta">
                {typeof log.meta?.time === "number" ? `t=${Number(log.meta.time).toFixed(2)}s` : ""}
                {typeof log.meta?.time === "number" && log.meta?.line && log.meta?.char ? " | " : ""}
                {log.meta?.line && log.meta?.char ? `line ${log.meta.line}, char ${log.meta.char}` : ""}
              </p>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default Console;
